"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Requirement =
/** @class */
function () {
  function Requirement(name, priority, fulfilled, data) {
    if (fulfilled === void 0) {
      fulfilled = false;
    }

    if (data === void 0) {
      data = null;
    }

    this.name = name;
    this.priority = priority;
    this.fulfilled = fulfilled;
    this.data = data;
  }

  Requirement.prototype.fulfill = function (data) {
    if (data === void 0) {
      data = null;
    }

    this.data = data;
    this.fulfilled = true;
  };

  return Requirement;
}();

exports.default = Requirement;